module.exports = __webpack_public_path__ + "assets/img/-2-min.c5c582e4.png";